module.exports = __webpack_public_path__ + "static/label_ats-5665edcf3bf24e4cb0dfbadb8bb48eac.png";